import o from "../_virtual/logger.js";
const e = o.get("ladon-ts"), g = Object.assign(e, {
  errorAndThrow(r) {
    throw e.error(r), new Error(r);
  }
}), n = o.createDefaultHandler({
  /**
   * Formatter for console logs.
   *
   * @param msg - Log message.
   * @param context - Log context.
   */
  formatter: (r, t) => {
    r.unshift(t.name);
  }
});
o.setHandler(n);
export {
  o as Logger,
  g as logger
};
//# sourceMappingURL=logger.js.map
